export default __webpack_public_path__ + "static/media/932.cc1dde16.png";